import { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { Config, ConfigProvider, Services, ServicesProvider } from 'core/common/contexts';
import { ObservabilityProvider } from 'core/common/observability/context';
import { FeatureFlagsProvider } from 'core/feature-flags/context';
import { FeatureFlags } from 'core/feature-flags/services';
import i18n from 'core/i18n';
import ThemeContext from 'core/theme_deprecated/contexts';
import { ThemeTypes } from 'core/theme_deprecated/entities';
import ErrorBoundary from '../ErrorBoundary';
import '@obrio/nebula-ui/styles.css';
import '@obrio/terms/styles.css';
import { Block, Container, Content, Wrapper } from './styled';

type PageLayoutProps = {
  children: ReactNode;
  store: Store;
  services: Services;
  featureFlags: FeatureFlags;
  config: Config;
  theme: ThemeTypes;
  screenId?: string;
};

const PageLayout = ({
  children,
  store,
  featureFlags,
  services,
  config,
  theme,
  screenId,
}: PageLayoutProps) => {
  return (
    <ErrorBoundary fallback={<div />}>
      <I18nextProvider i18n={i18n}>
        <ConfigProvider config={config}>
          <Provider store={store}>
            <ServicesProvider value={services}>
              <ObservabilityProvider>
                <FeatureFlagsProvider featureFlags={featureFlags}>
                  <ThemeContext themeType={theme}>
                    <Block data-testid={screenId}>
                      <Container>
                        <Content>
                          <Wrapper>{children}</Wrapper>
                        </Content>
                      </Container>
                    </Block>
                  </ThemeContext>
                </FeatureFlagsProvider>
              </ObservabilityProvider>
            </ServicesProvider>
          </Provider>
        </ConfigProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
};

export default PageLayout;
